import { untitleduiIcons } from '@packages/assets'

export const iconImages = {
  apple: require('./apple.svg'),
  archive: require('./archive.svg'),
  bell: require('./bell.svg'),
  bug: require('./bug.svg'),
  camera: require('./camera.svg'),
  check: require('./check.svg'),
  'chevron-down': require('./chevron-down.svg'),
  'chevron-left': require('./chevron-left.svg'),
  'chevron-right': require('./chevron-right.svg'),
  'chevron-up': require('./chevron-up.svg'),
  clock: require('./clock.svg'),
  'cloud-lightning': require('./cloud-lightning.svg'),
  cloud: require('./cloud.svg'),
  contact: require('./contact.svg'),
  contrast: require('./contrast.svg'),
  'edit-2': require('./edit-2.svg'),
  edit: require('./edit.svg'),
  'eye-off': require('./eye-off.svg'),
  eye: require('./eye.svg'),
  facebook: require('./facebook.svg'),
  'file-text': require('./file-text.svg'),
  file: require('./file.svg'),
  fingerprint: require('./fingerprint.svg'),
  folder: require('./folder.svg'),
  google: require('./google.svg'),
  heart: require('./heart.svg'),
  image: require('./image.svg'),
  info: require('./info.svg'),
  instapapper: require('./instapapper.svg'),
  key: require('./key.svg'),
  'lamp-floor': require('./lamp-floor.svg'),
  languages: require('./languages.svg'),
  layers: require('./layers.svg'),
  leaf: require('./leaf.svg'),
  'loader-2': require('./loader-2.svg'),
  linkedin: require('./linkedin.svg'),
  loader: require('./loader.svg'),
  'log-out': require('./log-out.svg'),
  mail: require('./mail.svg'),
  'map-pin': require('./map-pin.svg'),
  menu: require('./menu.svg'),
  'message-circle': require('./message-circle.svg'),
  mic: require('./mic.svg'),
  minus: require('./minus.svg'),
  'more-vertical': require('./more-vertical.svg'),
  plus: require('./plus.svg'),
  search: require('./search.svg'),
  settings: require('./settings.svg'),
  star: require('./star.svg'),
  share: require('./share.svg'),
  trash: require('./trash.svg'),
  telegram: require('./telegram.svg'),
  twitter: require('./twitter.svg'),
  tumblr: require('./tumblr.svg'),
  user: require('./user.svg'),
  'wifi-off': require('./wifi-off.svg'),
  wifi: require('./wifi.svg'),
  whatsapp: require('./whatsapp.svg'),
  x: require('./x.svg'),
  'heart-filled': require('./heart-filled.svg'),
  bookmark: require('./bookmark.svg'),
  'bookmark-filled': require('./bookmark-filled.svg'),
  phone: require('./phone.svg'),
  ...untitleduiIcons,
  'chat-3': require('./mingcute/chat-3-line.svg'),
  'settings-5': require('./mingcute/settings-5-line.svg'),
  'settings-5-fill': require('./settings-5-fill.svg'),
  'time-line': require('./mingcute/time-line.svg'),
  'checks': require('./mingcute/checks-line.svg'),
  'arrow-up': require('./mingcute/arrow-up-line.svg'),
  'checks-line': require('./mingcute/checks-line.svg'),
  'align-arrow-left-line': require('./mingcute/align-arrow-left-line.svg'),
  'bell-ringing-line': require('./mingcute/bell-ringing-line.svg'),
  'information-line': require('./mingcute/information-line.svg'),
  'key-2-line': require('./mingcute/key-2-line.svg'),
  'user-x-line': require('./mingcute/user-x-line.svg'),
  'user-4-line': require('./mingcute/user-4-line.svg'),
  'flag-3-line': require('./mingcute/flag-3-line.svg'),
  'upload-3-line': require('./mingcute/upload-3-line.svg'),
  'phone-line': require('./mingcute/phone-line.svg'),
  'close-circle-line': require('./mingcute/close-circle-line.svg'),
  'close-line': require('./mingcute/close-line.svg'),
  'face-smile': require('./mingcute/face-smile.svg'),
  'play-01': require('./mingcute/play-01.svg'),
  'pause-01': require('./mingcute/pause-01.svg'),
}
